export default "__VITE_PUBLIC_ASSET__3b95a927__"